import "./SlidedImage.css"
import a8 from "../assets/photos/yeni1.jpeg";
import a9 from "../assets/photos/yeni2.jpeg";
import a10 from "../assets/photos/yeni3.jpeg";
import m1 from "../assets/photos/mezarlık_kompleksi/1.jpeg"
import m2 from "../assets/photos/mezarlık_kompleksi/2.jpeg"
import m3 from "../assets/photos/mezarlık_kompleksi/3.jpeg"



import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const slideImages = [
    { url: m1, header: 'Planlı ve Kontrollü İLERLEYİŞ', caption: "İş Programına uyum içerisinde ilerleyen süreçler" },
    { url: m2, header: 'KALİTELİ MALZEME DÜZGÜN İŞÇİLİK', caption: "Şartnameye uygun ve kalite standartlarını sağlayan çevreye duyarlı üreticiler ile işçiliği en üst kaliteye çıkartıyoruz" },
    { url: m3, header: 'GÜÇLÜ YAPILAR, GÜVENLİ GELECEK', caption: "Onlarca projeyle şehrin silüetine değer katıyoruz" },
    { url: a8, header: 'Sağlam Temeller', caption: "Hayallerinizi inşa ediyoruz" },
    { url: a9, header: 'Güvenin Temeli', caption: "Yapı sektöründe 21 yıllık deneyimle sağlam projeler" },
    { url: a10, header: 'Geleceğe İz Bırakıyoruz', caption: "Sürdürülebilir, modern yapılar ile yarına değer katıyoruz. Şehirleri birlikte şekillendiriyoruz" },
];

const SlidedImage = () => {
    const [isMobile, setMobile] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [direction, setDirection] = useState(1); // YENİ - geçiş yönü

    useEffect(() => {
        if (window.innerWidth <= 768) setMobile(true);
    }, []);

    // YENİ - otomatik geçiş
    useEffect(() => {
        const timer = setInterval(() => {
            setDirection(1);
            setCurrentIndex(prev => (prev + 1) % slideImages.length);
        }, 7000);
        return () => clearInterval(timer);
    }, []);

    return (
        <div className="slided-image-container">
            {/* YENİ - arka plan fotoğrafı ayrı layer, smooth crossfade */}
            <AnimatePresence initial={false}>
                <motion.div
                    key={currentIndex}
                    className="slide-bg"
                    style={{ backgroundImage: `url(${slideImages[currentIndex].url})` }}
                    initial={{ x: "100%" }}
                    animate={{ x: "0%" }}
                    exit={{ x: "-100%" }}
                    transition={{ duration: 0.9, ease: [0.77, 0, 0.18, 1] }}
                />
            </AnimatePresence>

            {/* Gradient overlay */}
            <div className="slide-gradient" />

            {/* YENİ - metin ayrı layer */}
            <div className="slide-text-container" style={{ padding: isMobile ? "2rem 2rem 5rem" : "8rem 8rem 6rem" }}>
                <AnimatePresence mode="wait">
                    <motion.div
                        key={currentIndex}
                        initial={{ opacity: 0, x: 40 }}
                        animate={{ opacity: 1, x: 0 }}
                        exit={{ opacity: 0, x: -40 }}
                        transition={{ duration: 0.55, ease: "easeOut" }}
                        style={{ display: "flex", flexDirection: "column", gap: "0.75rem" }}
                    >
                

                        <motion.h1
                            className="slide-header"
                            style={{ fontSize: isMobile ? "2.2rem" : "4.5rem" }}
                            initial={{ opacity: 0, y: 15 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.2, duration: 0.55 }}
                        >
                            {slideImages[currentIndex].header}
                        </motion.h1>

                        <motion.p
                            className="slide-caption"
                            style={{ fontSize: isMobile ? "0.9rem" : "1.1rem" }}
                            initial={{ opacity: 0, y: 15 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.35, duration: 0.55 }}
                        >
                            {slideImages[currentIndex].caption}
                        </motion.p>
                    </motion.div>
                </AnimatePresence>
            </div>

            {/* Göstergeler */}
            <div className="slide-indicators">
                {slideImages.map((_, i) => (
                    <div
                        key={i}
                        className={`slide-dot ${currentIndex === i ? 'active' : ''}`}
                        onClick={() => { setDirection(i > currentIndex ? 1 : -1); setCurrentIndex(i); }}
                    />
                ))}
            </div>

            {/* Scroll indicator */}
            <div className="scroll-indicator">
                <div className="scroll-indicator-line" />
            </div>
        </div>
    );
};

export default SlidedImage;